/* eslint-disable eqeqeq */
import moment from 'moment';
import React from 'react';
import { toast } from 'react-toastify';
import { container } from 'tsyringe';
import { JenisPelatihanPresenter } from '../../../../../../data/presenters/JenisPelatihanPresenter';
import { MenuJenisPelatihanPresenter } from '../../../../../../data/presenters/MenuJenisPelatihanPresenter';
import { PelatihanPresenter } from '../../../../../../data/presenters/PelatihanPresenter';
import { JenisPelatihan } from '../../../../../../entities/JenisPelatihan';
import { SubMenuJenisPelatihan } from '../../../../../../entities/MenuJenisPelatihan';
import history from '../../../../../../history';
import axiosInstance from '../../../../../api/axiosInstance';
import {
  CACHE_KEYS,
  CACHE_TTL,
  getCache,
  setCache,
} from '../../../../../misc/CacheStorage';

export interface OptionMultiSelect {
  value: any;
  label: string;
  key?: string;
  disabled?: boolean;
}

type OptionType = {
  value: string;
  label: string;
};
interface IState {
  isLoading: boolean;
  path_thumbnail: any;
  jenis_pelatihan_id: number;
  sub_menu_jenis_pelatihan_id: number;
  waktu_mulai: string;
  waktu_selesai: string;
  waktu_mulai_pendaftaran: string;
  waktu_selesai_pendaftaran: string;
  penyelenggara: string;
  informasi_umum: string;
  kompetensi_teknis: string;
  persyaratan: string;
  angkatan: string;
  jenisPelatihan: JenisPelatihan[];
  subMenuJenisPelatihan: SubMenuJenisPelatihan[];
  msgError: any[];
  isPPKB: boolean;
  materiInti: string;
  eventId: string;
  isPretest: boolean;
  isForGuruMadrasah: boolean;
  isForPesantren: boolean;
  tidakAdaPenilaian: boolean;
  isCustomJenisPenilaian: boolean;
  jenis_penilaian_id: string;
  listOptionsJenisPenilaian: OptionType[];
  jenisPenilaianSelected: OptionType | null;
  listAdminNonLembaga: OptionType[];
  adminNonLembagaSelected: OptionType[];
  accessAdminNonLembaga: boolean;
  linkEvaluasi: string;
  accessLinkEvaluasi: boolean;
  logoPenyelenggara: any;
  isPelatihanSerial: boolean;
  jenisPrasyarat: 'jabatan' | 'pelatihan_relevan';
  listJabatan: OptionType[];
  jabatanSelected: OptionMultiSelect[];
  listPelatihanRelevan: OptionType[];
  pelatihanRelevanSelected: OptionType | null;
}

interface InitialState {
  state: IState;
  createPelatihan: Function;
  setPathThumbnail: Function;
  setJenisPelatihanId: Function;
  setSubMenuJenisPelatihanId: Function;
  setWaktuMulai: Function;
  setWaktuSelesai: Function;
  setWaktuMulaiPendaftaran: Function;
  setWaktuSelesaiPendaftaran: Function;
  setPenyelenggara: Function;
  setInformasiUmum: Function;
  setKompetensiTeknis: Function;
  setPersyaratan: Function;
  setAngkatan: Function;
  getJenisPelatihan: Function;
  getSubMenuJenisPelatihan: Function;
  setIsPPKB: Function;
  setCreateManajemenPelatihan: Function;
  setEventId: Function;
  setIsPretest: Function;
  getJenisPenilaian: Function;
  setJenisPenilaian: Function;
  getListAdminNonLembaga: Function;
  setAdminNonLembaga: Function;
  setLinkEvaluasi: Function;
  setAccessLinkEvaluasi: Function;
  setLogoPenyelenggara: Function;
  setIsPelatihanSerial: Function;
  setJenisPrasyarat: Function;
  getListJabatan: Function;
  setJabatanSelected: Function;
  getListPelatihanRelevan: Function;
  setPelatihanRelevanSelected: Function;
}

const initialState: InitialState = {
  state: {
    isLoading: false,
    path_thumbnail: null,
    jenis_pelatihan_id: 0,
    sub_menu_jenis_pelatihan_id: 0,
    waktu_mulai: '',
    waktu_selesai: '',
    waktu_mulai_pendaftaran: '',
    waktu_selesai_pendaftaran: '',
    penyelenggara: '',
    informasi_umum: '',
    kompetensi_teknis: '',
    persyaratan: '',
    angkatan: '',
    jenisPelatihan: [],
    subMenuJenisPelatihan: [],
    msgError: [],
    isPPKB: false,
    materiInti: '',
    eventId: '',
    isPretest: false,
    isForGuruMadrasah: false,
    isForPesantren: false,
    tidakAdaPenilaian: false,
    isCustomJenisPenilaian: false,
    jenis_penilaian_id: '',
    listOptionsJenisPenilaian: [],
    jenisPenilaianSelected: null,
    listAdminNonLembaga: [],
    adminNonLembagaSelected: [],
    accessAdminNonLembaga: false,
    linkEvaluasi: '',
    accessLinkEvaluasi: false,
    logoPenyelenggara: null,
    isPelatihanSerial: false,
    jenisPrasyarat: 'jabatan',
    listJabatan: [],
    jabatanSelected: [],
    listPelatihanRelevan: [],
    pelatihanRelevanSelected: null,
  },
  createPelatihan: () => {},
  setPathThumbnail: () => {},
  setJenisPelatihanId: () => {},
  setSubMenuJenisPelatihanId: () => {},
  setWaktuMulai: () => {},
  setWaktuSelesai: () => {},
  setWaktuMulaiPendaftaran: () => {},
  setWaktuSelesaiPendaftaran: () => {},
  setPenyelenggara: () => {},
  setInformasiUmum: () => {},
  setKompetensiTeknis: () => {},
  setPersyaratan: () => {},
  setAngkatan: () => {},
  getJenisPelatihan: () => {},
  getSubMenuJenisPelatihan: () => {},
  setIsPPKB: () => {},
  setCreateManajemenPelatihan: () => {},
  setEventId: () => {},
  setIsPretest: () => {},
  getJenisPenilaian: () => {},
  setJenisPenilaian: () => {},
  getListAdminNonLembaga: () => {},
  setAdminNonLembaga: () => {},
  setLinkEvaluasi: () => {},
  setAccessLinkEvaluasi: () => {},
  setLogoPenyelenggara: () => {},
  setIsPelatihanSerial: () => {},
  setJenisPrasyarat: () => {},
  getListJabatan: () => {},
  setJabatanSelected: () => {},
  getListPelatihanRelevan: () => {},
  setPelatihanRelevanSelected: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: ManajemenPelatihanCreateProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    path_thumbnail: null,
    jenis_pelatihan_id: 0,
    sub_menu_jenis_pelatihan_id: 0,
    waktu_mulai: '',
    waktu_selesai: '',
    waktu_mulai_pendaftaran: '',
    waktu_selesai_pendaftaran: '',
    penyelenggara: '',
    informasi_umum: '',
    kompetensi_teknis: '',
    persyaratan: '',
    angkatan: '',
    jenisPelatihan: [],
    subMenuJenisPelatihan: [],
    msgError: [],
    isPPKB: false,
    materiInti: '',
    eventId: '',
    isPretest: false,
    isForGuruMadrasah: false,
    isForPesantren: false,
    tidakAdaPenilaian: false,
    isCustomJenisPenilaian: false,
    jenis_penilaian_id: '',
    listOptionsJenisPenilaian: [],
    jenisPenilaianSelected: null,
    listAdminNonLembaga: [],
    adminNonLembagaSelected: [],
    accessAdminNonLembaga: false,
    linkEvaluasi: '',
    accessLinkEvaluasi: false,
    logoPenyelenggara: null,
    isPelatihanSerial: false,
    jenisPrasyarat: 'jabatan',
    listJabatan: [],
    jabatanSelected: [],
    listPelatihanRelevan: [],
    pelatihanRelevanSelected: null,
  });

  const setCreateManajemenPelatihan = <K extends keyof IState>(
    key: K,
    value: IState[K]
  ) => {
    setState((prevstate) => ({
      ...prevstate,
      [key]: value,
    }));

    if (key == 'accessAdminNonLembaga' && value === false) {
      setState((prevstate) => ({
        ...prevstate,
        adminNonLembagaSelected: [],
      }));
    }
  };

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const setIsPretest = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isPretest: value,
    }));
  };

  const setEventId = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      eventId: value,
    }));
  };

  const createPelatihan = async () => {
    setLoading(true);

    if (
      state.path_thumbnail == null ||
      state.jenis_pelatihan_id == 0 ||
      state.sub_menu_jenis_pelatihan_id == 0 ||
      state.waktu_mulai == '' ||
      state.waktu_selesai == '' ||
      state.waktu_mulai_pendaftaran == '' ||
      state.waktu_selesai_pendaftaran == '' ||
      state.penyelenggara == '' ||
      state.informasi_umum == '' ||
      state.persyaratan == '' ||
      state.angkatan == '' ||
      state.jenisPenilaianSelected === null ||
      (state.accessAdminNonLembaga &&
        state.adminNonLembagaSelected.length == 0) ||
      (state.accessLinkEvaluasi && state.linkEvaluasi == '') ||
      (state.isPelatihanSerial &&
        state.jenisPrasyarat === 'jabatan' &&
        state.jabatanSelected.length == 0) ||
      (state.isPelatihanSerial &&
        state.jenisPrasyarat === 'pelatihan_relevan' &&
        state.pelatihanRelevanSelected === null)
    ) {
      toast('Data Belum Terisi Lengkap!');
      setLoading(false);
      return;
    }

    try {
      const pelatihanPresenter = container.resolve(PelatihanPresenter);

      const store = await pelatihanPresenter.storePelatihan(
        state.path_thumbnail,
        state.sub_menu_jenis_pelatihan_id,
        state.jenis_pelatihan_id,
        moment(state.waktu_mulai).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_selesai).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_mulai_pendaftaran).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_selesai_pendaftaran).format('YYYY-MM-DD HH:mm:ss'),
        state.penyelenggara,
        state.informasi_umum,
        state.kompetensi_teknis,
        state.persyaratan,
        state.angkatan,
        state.isPPKB,
        state.isPPKB ? state.materiInti : '',
        state.eventId,
        state.isPretest,
        state.isForGuruMadrasah,
        state.isForPesantren,
        state.tidakAdaPenilaian,
        state.jenisPenilaianSelected?.value ?? '',
        state.adminNonLembagaSelected,
        state.linkEvaluasi,
        state.logoPenyelenggara,
        state.pelatihanRelevanSelected?.value ?? '',
        state.jabatanSelected
      );

      const data = store;

      if (data.data.code == 200) {
        toast('Berhasil Menambahkan Data Baru.');

        history.replace(
          `/admin/kelola_konten/manajemen_pelatihan/${data.data.data.uuid}`
        );
        window.location.reload();
      } else {
        toast('Ada Kesalahan Saat Tambah Data!');
      }
      setLoading(false);
    } catch (error: any) {
      console.error('error pelatihan:', error);
      toast('Ada Kesalahan Saat Tambah Data!');
      if (error.response.data?.errors) {
        setState((prevstate) => ({
          ...prevstate,
          msgError: [error.response.data?.errors],
        }));
      }
      setLoading(false);
    }
  };

  const setPathThumbnail = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      path_thumbnail: value,
    }));
  };

  const setJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jenis_pelatihan_id: value,
    }));
  };

  const setSubMenuJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      sub_menu_jenis_pelatihan_id: value,
    }));
  };

  const setWaktuMulai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_mulai: value,
    }));
  };

  const setWaktuSelesai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_selesai: value,
    }));
  };

  const setWaktuMulaiPendaftaran = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_mulai_pendaftaran: value,
    }));
  };

  const setWaktuSelesaiPendaftaran = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_selesai_pendaftaran: value,
    }));
  };

  const setPenyelenggara = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      penyelenggara: value,
    }));
  };

  const setInformasiUmum = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      informasi_umum: value,
    }));
  };

  const setKompetensiTeknis = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      kompetensi_teknis: value,
    }));
  };

  const setPersyaratan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      persyaratan: value,
    }));
  };

  const setAngkatan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      angkatan: value,
    }));
  };

  const setIsPPKB = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isPPKB: value,
    }));
  };

  const getJenisPelatihan = async (sub_menu_jenis_pelatihan_id: string) => {
    try {
      const jenisPelatihan = container.resolve(JenisPelatihanPresenter);

      const get = await jenisPelatihan.getAllJenisPelatihan(
        1,
        10000000,
        '',
        sub_menu_jenis_pelatihan_id
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        jenisPelatihan: data,
      }));
    } catch (error: any) {
      console.error('error get Jenis Pelatihan:', error);
    }
  };

  const getSubMenuJenisPelatihan = async () => {
    try {
      const menuJenisPelatihanPresenter = container.resolve(
        MenuJenisPelatihanPresenter
      );

      const get = await menuJenisPelatihanPresenter.getAllSubMenuJenisPelatihan(
        1,
        10000000,
        ''
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        subMenuJenisPelatihan: data,
      }));
    } catch (error: any) {
      console.error('error get Sub Menu Jenis Pelatihan:', error);
    }
  };

  const setJenisPenilaian = (value: OptionType) => {
    setState((prevstate) => ({
      ...prevstate,
      jenisPenilaianSelected: value,
    }));
  };

  const getJenisPenilaian = async () => {
    try {
      const { data } = await axiosInstance.get('jenis_penilaian');
      const listJenisPenialain = data?.data.map((item) => {
        return {
          value: item.id,
          label: item.nama_jenis_penilaian,
        };
      });

      setState((prevstate) => ({
        ...prevstate,
        listOptionsJenisPenilaian: listJenisPenialain,
      }));
    } catch (error) {
      throw error;
    }
  };

  const getListAdminNonLembaga = async () => {
    try {
      const pelatihan = container.resolve(PelatihanPresenter);

      const get = await pelatihan.getAdminNonlembaga();

      const data = get;

      const listAdminNonLembaga = data?.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });

      setState((prevstate) => ({
        ...prevstate,
        listAdminNonLembaga: listAdminNonLembaga,
      }));
    } catch (error: any) {
      console.error('error get admin non lembaga:', error);
    }
  };

  const setAdminNonLembaga = (value: OptionType[]) => {
    setState((prevstate) => ({
      ...prevstate,
      adminNonLembagaSelected: value,
    }));
  };

  const setLinkEvaluasi = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      linkEvaluasi: value,
    }));
  };

  const setAccessLinkEvaluasi = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      accessLinkEvaluasi: value,
    }));
  };

  const setLogoPenyelenggara = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      logoPenyelenggara: value,
    }));
  };

  const setIsPelatihanSerial = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isPelatihanSerial: value,
    }));
  };

  const setJenisPrasyarat = (value: 'jabatan' | 'pelatihan_relevan') => {
    setState((prevstate) => ({
      ...prevstate,
      jenisPrasyarat: value,
    }));
  };

  const getListJabatan = async (forceRefresh: boolean = false) => {
    try {
      if (!forceRefresh) {
        const cachedData = getCache<OptionType[]>(CACHE_KEYS.LIST_JABATAN);
        if (cachedData) {
          setState((prevstate) => ({
            ...prevstate,
            listJabatan: cachedData,
          }));
          return;
        }
      }

      const { data } = await axiosInstance.get('simdiklat/master_data/jabatan');

      const listJabatanMapping = data?.data.map((item) => {
        return {
          value: item.nama,
          label: item.nama,
        };
      });

      setCache(
        CACHE_KEYS.LIST_JABATAN,
        listJabatanMapping,
        CACHE_TTL.MASTER_DATA
      );

      setState((prevstate) => ({
        ...prevstate,
        listJabatan: listJabatanMapping,
      }));
    } catch (error) {
      console.error('Error fetching list jabatan:', error);
      throw error;
    }
  };

  const setJabatanSelected = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      jabatanSelected: value,
    }));
  };

  const getListPelatihanRelevan = async (forceRefresh: boolean = false) => {
    try {
      if (!forceRefresh) {
        const cachedData = getCache<OptionType[]>(
          CACHE_KEYS.LIST_PELATIHAN_RELEVAN
        );
        if (cachedData) {
          setState((prevstate) => ({
            ...prevstate,
            listPelatihanRelevan: cachedData,
          }));
          return;
        }
      }

      const { data } = await axiosInstance.get('pelatihan/relevan/list', {
        params: {
          page: 1,
          rows: 10000000,
        },
      });

      const listPelatihanRelevanMapping = data?.data.map((item) => {
        return {
          value: item.id,
          label: item.judul_pelatihan,
        };
      });

      setCache(
        CACHE_KEYS.LIST_PELATIHAN_RELEVAN,
        listPelatihanRelevanMapping,
        CACHE_TTL.MASTER_DATA
      );

      setState((prevstate) => ({
        ...prevstate,
        listPelatihanRelevan: listPelatihanRelevanMapping,
      }));
    } catch (error) {
      console.error('Error fetching list pelatihan relevan:', error);
      throw error;
    }
  };

  const setPelatihanRelevanSelected = (value: OptionType) => {
    setState((prevstate) => ({
      ...prevstate,
      pelatihanRelevanSelected: value,
    }));
  };

  return (
    <ManajemenPelatihanCreateProvider
      value={{
        state,
        createPelatihan,
        setPathThumbnail,
        setJenisPelatihanId,
        setSubMenuJenisPelatihanId,
        setWaktuMulai,
        setWaktuSelesai,
        setWaktuMulaiPendaftaran,
        setWaktuSelesaiPendaftaran,
        setPenyelenggara,
        setInformasiUmum,
        setKompetensiTeknis,
        setPersyaratan,
        setAngkatan,
        getJenisPelatihan,
        getSubMenuJenisPelatihan,
        setIsPPKB,
        setCreateManajemenPelatihan,
        setEventId,
        setIsPretest,
        getJenisPenilaian,
        setJenisPenilaian,
        getListAdminNonLembaga,
        setAdminNonLembaga,
        setLinkEvaluasi,
        setAccessLinkEvaluasi,
        setLogoPenyelenggara,
        setIsPelatihanSerial,
        setJenisPrasyarat,
        getListJabatan,
        setJabatanSelected,
        getListPelatihanRelevan,
        setPelatihanRelevanSelected,
      }}
    >
      {children}
    </ManajemenPelatihanCreateProvider>
  );
};

export const useManajemenPelatihanCreateContext = () =>
  React.useContext(Context);
// eslint-disable-next-line
export default {
  useManajemenPelatihanCreateContext,
  Provider,
};
